import { useQuery } from '@tanstack/react-query'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export type GetDocumentUrlRes = {
  url: string
}

interface Props {
  documentId?: number
}

export function useGetDocumentUrl({ documentId }: Props) {
  const fetchRequest = useFetch<GetDocumentUrlRes>()

  return useQuery({
    queryKey: ['/documents/:documentId/download', documentId],
    queryFn: async () =>
      await fetchRequest(`${apiBase()}/documents/${documentId}/download`),
    enabled: false,
  })
}
